webpackJsonp([43],{

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(52)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(838),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      beingSaved: false,
      // component specific
      tab: 'tab-0',
      tabitems: ['heads', 'opening balance'],
      lHead: '',
      heads: {},
      types: [],
      hclass: {},
      headHead: [{ text: 'Name', value: 'gl_acc_name' }, { text: 'Default', value: 'is_system_acc', width: '100px' }],
      dlgHead: false,
      balHead: [{ text: 'Name', value: 'gl_acc_name' }, { text: 'Debit', value: 'opening_debit', width: '100px', align: 'right' }, { text: 'Credit', value: 'opening_credit', width: '100px', align: 'right' }],
      period: null,
      periods: [],
      preType: '',
      totDebit: 0,
      totCredit: 0,
      filterBal: false,
      incomeHeads: [],
      expHeads: []
    };
  },

  computed: {
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(Date());
    }
  },
  created: function created() {
    // load account head types and list
    this.loadHeads();
    this.loadIncomeExpHeads();
  },
  mounted: function mounted() {
    this.loading();
    this.lAction = 'view';
  },

  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    loading: function loading() {
      var _this = this;

      this.load = true;
      setTimeout(function () {
        _this.load = false;
      }, 500);
    },
    getEmptyHead: function getEmptyHead() {
      var emptyHead = {
        comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
        gl_acc_name: '',
        gl_acc_type: '',
        gl_acc_class: null,
        opening_debit: null,
        opening_credit: null,
        is_system_acc: false
      };
      return emptyHead;
    },
    cancelChanges: function cancelChanges() {
      this.dlgHead = false;
      this.lAction = 'view';
      this.lHead = '';
    },
    deleteHead: function deleteHead() {
      // confirm
      if (confirm('Sure, you want to delete the head "' + this.lHead.gl_acc_name + '"?')) {
        // delete
        this.saveChanges('delete');
      }
    },
    prepareCreate: function prepareCreate() {
      this.lHead = this.getEmptyHead();
      this.dlgHead = true;
      this.lAction = 'create';
    },
    prepareUpdate: function prepareUpdate(curHead) {
      this.lHead = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curHead); // keep the original object safely before changes
      this.preType = curHead.gl_acc_type;
      this.dlgHead = true;
      this.lAction = 'update';
    },
    prepareUpdateBal: function prepareUpdateBal(curHead) {
      this.lHead = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curHead); // keep the original object safely before changes
      this.lHead.bal_trans_type = this.lHead.opening_debit > 0 ? 'Debit' : this.lHead.opening_credit > 0 ? 'Credit' : this.lHead.gl_acc_type === 'ASSET' || this.lHead.gl_acc_type === 'EXPENSE' || this.lHead.gl_acc_type === 'PERSONAL' ? 'Debit' : 'Credit';
      this.lHead.bal_amount = this.lHead.opening_debit > 0 ? this.lHead.opening_debit : this.lHead.opening_credit;
      this.dlgHead = true;
      this.lAction = 'update';
    },
    saveChanges: function saveChanges(action) {
      var _this2 = this;

      // validate and save Changes
      if (action === 'create' || action === 'update' || action === 'update-op-bal') {
        if (!this.$refs.lForm.validate()) {
          return;
        }
      }
      this.beingSaved = true;
      // pre-req
      if (action === 'update-op-bal') {
        if (this.lHead.bal_trans_type === 'Debit') {
          this.lHead.opening_debit = this.lHead.bal_amount;
          this.lHead.opening_credit = 0;
        } else {
          this.lHead.opening_debit = 0;
          this.lHead.opening_credit = this.lHead.bal_amount;
        }
      }
      // set agr account if the account being updated is personal account
      if (this.lHead.gl_acc_type === 'PERSONAL') {
        if (this.lHead.bal_trans_type === 'Debit') {
          this.lHead.agr_gl_acc_id = this.expHeads.find(function (rec) {
            return rec.gl_acc_name === 'Accounts Receivable - Members';
          }).gl_acc_id;
        } else {
          this.lHead.agr_gl_acc_id = this.incomeHeads.find(function (rec) {
            return rec.gl_acc_name === 'Accounts Payable';
          }).gl_acc_id;
        }
      }
      setTimeout(function () {
        _this2.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/head/' + action, _this2.lHead).then(function (response) {
          // refresh list in front end
          _this2.loadHeads();
          _this2.loading();
          _this2.dlgHead = false;
          _this2.lAction = 'view';
          _this2.beingSaved = false;
        }).catch(function (err) {
          _this2.msg(err.response.data, true);
          _this2.beingSaved = false;
        });
      }, 1000);
    },
    loadHeads: function loadHeads() {
      var _this3 = this;

      // load current finance year by default
      if (!this.period) {
        // derive current period
        var year = new Date().getFullYear();
        var month = new Date().getMonth();
        if (month > 2) {
          this.maintFrom = '01 Apr ' + year;
          this.maintTo = '31 Mar ' + (Number(year) + 1);
        } else {
          this.maintFrom = '01 Apr ' + (Number(year) - 1);
          this.maintTo = '31 Mar ' + year;
        }
        // set current year as default one
        this.period = this.maintFrom + ' - ' + this.maintTo;
      } else {
        this.maintFrom = this.period.substring(0, this.period.indexOf(' - '));
        this.maintTo = this.period.substring(this.period.indexOf(' - ') + 3);
      }

      // load list of head types
      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAccountTypeByCommId/', qry).then(function (response) {
        _this3.types = response.data.map(function (rec) {
          return rec.gl_acc_type;
        });
        var qry = {
          params: {
            trans_dt_from: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this3.maintFrom),
            trans_dt_to: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.formatDBDate(_this3.maintTo),
            comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
          }
          // load heads under each type
        };_this3.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAccountHeadsByCommId/', qry).then(function (response) {
          _this3.types.forEach(function (hType) {
            _this3.heads[hType] = response.data.filter(function (rec) {
              return rec.gl_acc_type === hType;
            });
            // head classifications
            // default
            _this3.hclass[hType] = [];
            if (hType === 'ASSET') {
              _this3.hclass[hType] = ['Fixed Assets', 'Investments', 'Banks', 'Current Assets'];
            } else if (hType === 'LIABILITY') {
              _this3.hclass[hType] = ['Capital', 'Long-term Liabilities', 'Current Liabilities'];
            }
            // available
            _this3.hclass[hType] = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(_this3.hclass[hType].concat(_this3.heads[hType].filter(function (rec) {
              return rec.gl_acc_class;
            }).map(function (rec) {
              return rec.gl_acc_class;
            })));
          });
          // total debit and credit
          _this3.refreshAmount();
        });
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
      });

      // load other financial periods if available
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getAvailableFinPeriodByCommId/', qry).then(function (response) {
        if (response.data.length) {
          var availYears = __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.unique(response.data.map(function (rec) {
            return new Date(rec.avail_dates).getFullYear();
          }));
          availYears.forEach(function (rec) {
            _this3.periods.push('01 Apr ' + rec + ' - ' + '31 Mar ' + (rec + 1));
          });
        } else {
          // default period
          _this3.periods.push(_this3.period);
        }
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
      });
    },
    loadIncomeExpHeads: function loadIncomeExpHeads() {
      var _this4 = this;

      var qry = {
        params: {
          comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getIncomeExpensesHeadsByCommId/', qry).then(function (response) {
        _this4.incomeHeads = response.data.filter(function (rec) {
          return rec.gl_acc_type === 'INCOME' || rec.gl_acc_type === 'LIABILITY' || rec.gl_acc_type === 'PERSONAL';
        });
        _this4.expHeads = response.data.filter(function (rec) {
          return rec.gl_acc_type === 'EXPENSE' || rec.gl_acc_type === 'ASSET' || rec.gl_acc_type === 'PERSONAL';
        });
      }).catch(function (err) {
        _this4.msg(err.response.data, true);
        _this4.incomeHeads = [];
        _this4.expHeads = [];
      });
    },
    refreshAmount: function refreshAmount() {
      var _this5 = this;

      this.totDebit = 0;
      this.totCredit = 0;
      this.types.forEach(function (hType) {
        _this5.totDebit += _this5.heads[hType].map(function (rec) {
          return rec.opening_debit;
        }).reduce(function (a, b) {
          return Number(a) + Number(b);
        }, 0);
        _this5.totCredit += _this5.heads[hType].map(function (rec) {
          return rec.opening_credit;
        }).reduce(function (a, b) {
          return Number(a) + Number(b);
        }, 0);
      });
    }
  }
});

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [_c('v-layout', {
      staticClass: "pa-1"
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md9": "",
        "offset-sm3": "",
        "mx-auto": ""
      }
    }, [(tabitem === 'heads') ? _c('div', {
      staticClass: "text-xs-right caption ma-2 grey--text"
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("lock")]), _vm._v(" - System defaults which can not be modified\n                ")], 1) : _c('div', [_c('v-layout', {
      staticClass: "ml-1 mr-1",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": "",
        "sm4": ""
      }
    }, [_c('v-select', {
      attrs: {
        "label": "Maintenance period",
        "items": _vm.periods
      },
      on: {
        "input": function($event) {
          return _vm.loadHeads()
        }
      },
      model: {
        value: (_vm.period),
        callback: function($$v) {
          _vm.period = $$v
        },
        expression: "period"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": "Filter accounts with opening balance",
        "hide-details": ""
      },
      model: {
        value: (_vm.filterBal),
        callback: function($$v) {
          _vm.filterBal = $$v
        },
        expression: "filterBal"
      }
    })], 1), _vm._v(" "), (tabitem !== 'heads') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm8": "",
        "mx-auto": ""
      }
    }, [_c('v-layout', {
      class: 'mr-1 subheading white--text ' + (_vm.totDebit === _vm.totCredit ? 'success' : 'error'),
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Total ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Debit: " + _vm._s(_vm.handy.formatCur(_vm.totDebit)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs5": "",
        "sm4": ""
      }
    }, [_c('strong', [_vm._v("Credit: " + _vm._s(_vm.handy.formatCur(_vm.totCredit)))])]), _vm._v(" "), (_vm.totDebit !== _vm.totCredit) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                            Difference in opening balance " + _vm._s(_vm.handy.formatCur(_vm.totDebit - _vm.totCredit)) + "\n                          ")])]) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.types), function(hType, t) {
      return _c('div', {
        key: t
      }, [(hType !== 'PERSONAL' || tabitem === 'opening balance') ? _c('v-card', {
        staticClass: "mb-3"
      }, [_c('v-card-title', {
        staticClass: "pa-2 grey lighten-4"
      }, [_c('div', {
        staticClass: "title grey--text"
      }, [_vm._v(_vm._s(hType))])]), _vm._v(" "), _c('v-card-text', {
        staticClass: "pa-0"
      }, [_c('v-data-table', {
        attrs: {
          "headers": tabitem === 'heads' ? _vm.headHead : _vm.balHead,
          "items": _vm.heads[hType],
          "hide-actions": "",
          "disable-initial-sort": "",
          "hide-actions": ""
        },
        scopedSlots: _vm._u([{
          key: "items",
          fn: function(props) {
            return [(!_vm.filterBal || props.item.opening_debit || props.item.opening_credit) ? _c('tr', {
              on: {
                "click": function($event) {
                  tabitem !== 'heads' ? _vm.prepareUpdateBal(props.item) : !props.item.is_system_acc ? _vm.prepareUpdate(props.item) : ''
                }
              }
            }, [_c('td', [_vm._v(_vm._s(props.item.gl_acc_name))]), _vm._v(" "), (tabitem === 'heads') ? _c('td', [(props.item.is_system_acc) ? _c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("lock")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (tabitem !== 'heads') ? _c('td', {
              staticClass: "text-xs-right"
            }, [_vm._v(_vm._s((props.item.opening_debit ? _vm.handy.formatCur(props.item.opening_debit) : props.item.opening_debit)))]) : _vm._e(), _vm._v(" "), (tabitem !== 'heads') ? _c('td', {
              staticClass: "text-xs-right"
            }, [_vm._v(_vm._s((props.item.opening_credit ? _vm.handy.formatCur(props.item.opening_credit) : props.item.opening_credit)))]) : _vm._e()]) : _vm._e()]
          }
        }], null, true)
      })], 1)], 1) : _vm._e()], 1)
    })], 2)], 1)], 1)
  }), _vm._v(" "), (_vm.tab === 'tab-0') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dlgHead),
      callback: function($$v) {
        _vm.dlgHead = $$v
      },
      expression: "dlgHead"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.tab === 'tab-0' ? _vm.saveChanges(_vm.lAction) : _vm.saveChanges('update-op-bal')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.tab === 'tab-1') ? _c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.lHead.gl_acc_name + ' (' + _vm.lHead.gl_acc_type + ')') + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.tab === 'tab-0') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Head Name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.lHead.gl_acc_name),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_name", $$v)
      },
      expression: "lHead.gl_acc_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": ['ASSET', 'LIABILITY', 'INCOME', 'EXPENSE'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.gl_acc_type),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_type", $$v)
      },
      expression: "lHead.gl_acc_type"
    }
  })], 1), _vm._v(" "), (_vm.lHead.gl_acc_type === 'ASSET' || _vm.lHead.gl_acc_type === 'LIABILITY') ? _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Class (choose/enter new)",
      "items": _vm.hclass[_vm.lHead.gl_acc_type],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.gl_acc_class),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "gl_acc_class", $$v)
      },
      expression: "lHead.gl_acc_class"
    }
  })], 1) : _vm._e()], 1) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['Debit', 'Credit'],
      "hint": _vm.lHead.gl_acc_type === 'PERSONAL' ? (_vm.lHead.bal_trans_type === 'Debit' ? 'i.e due from this person' : 'i.e you owe to this person') : '',
      "persistent-hint": ""
    },
    on: {
      "input": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.lHead.bal_trans_type),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "bal_trans_type", $$v)
      },
      expression: "lHead.bal_trans_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.config.CURRENCY,
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lHead.bal_amount),
      callback: function($$v) {
        _vm.$set(_vm.lHead, "bal_amount", $$v)
      },
      expression: "lHead.bal_amount"
    }
  })], 1), _vm._v(" "), (_vm.lHead.gl_acc_type === 'PERSONAL') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "value": "true",
      "color": "info"
    }
  }, [(_vm.lHead.bal_trans_type === 'Debit') ? _c('span', [_vm._v("\n                      Don't forget to "), _c('strong', [_vm._v("credit")]), _vm._v(" corresponding income heads for this due amount to balance the total amount. Ignore if already done.\n                    ")]) : _c('span', [_vm._v("\n                      Don't forget to "), _c('strong', [_vm._v("debit")]), _vm._v(" corresponding bank/cash heads for this excess/surplus amount to balance the total amount. Ignore if already done.\n                    ")])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.tab === 'tab-0' && _vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteHead($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.beingSaved,
      "type": "submit",
      "color": "accent",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20%",
      "left": "50%"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/43.bdf7d8c2755f168cc08c.js